import { Link, useLocation } from "react-router-dom";

import { Space, Breadcrumb, Button } from "antd";
import type { ColumnsType } from "antd/es/table";
import { PageHeader } from "@ant-design/pro-layout";

import {
   Site, DeviceData
} from "../../model/model";
import SessionStore from "../../model/SessionStore";

import type { GetPageCallbackFunc } from "../../components/DataTable";
import DataTable from "../../components/DataTable";

interface IProps {
  site: Site;
}

function ListSiteDevices(props: IProps) {
  const location = useLocation();

  const columns: ColumnsType<DeviceData> = [
    {
      title: "name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => <Link to={`/site/${props.site.id}/device/${record.id}`}>{record.name}</Link>,
    },
    {
      title: "Desription",
      dataIndex: "descr",
      key: "descr",
      render: (text, record) => {
          return record.descr;
      },
    },
  ];

  const getPage = (limit: number, offset: number, callbackFunc: GetPageCallbackFunc) => {
    const siteId :string = props.site.id;
    SessionStore.getClient().getSiteDevices(siteId, SessionStore.getBearer()).then( (resp) => {
      const obj = resp.data;
      callbackFunc(obj.length, obj);
    });
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb>
            <Breadcrumb.Item>
              <span>Sites</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>
                <Link to={`/site/${props.site.id}/dash`}>{props.site.name}</Link>
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Site devices</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        title="Site devices"
        extra={[
            <Button type="primary">
              <Link to={`/site/${props.site.id}/devices/create`}>Add site device</Link>
            </Button>
        ]}
      />
      <DataTable columns={columns} getPage={getPage} rowKey="id" refreshKey={location.key} />
    </Space>
  );
}

export default ListSiteDevices;
